<div class="lum-modal">
  <div class="lum-modal__header justify-space-between w-p100">
    <span class="lum-modal__header-title flex text-large">{{
      mode === 'Create' ? 'Create Client Profile' : 'Edit Client Profile'
    }}</span>
    <div class="lum-modal__header-close">
      <button
        type="button"
        class="close"
        (click)="onClose()"
        aria-label="Close Client Profile Dialog"
      >
        <lum-ui-icon
          class="mr-2-5"
          icon="close-circle"
          color="var(--col-cloud-600)"
          width="23"
          height="23"
        ></lum-ui-icon>
      </button>
    </div>
  </div>
  <div class="lum-modal__body">
    <!-- Tabs -->
    <mat-tab-group
      mat-stretch-tabs="true"
      class="tab-list lum-mat-tab-group"
      (selectedTabChange)="selectedTab($event)"
      #tabGroup
    >
      <!-- Client Profile -->
      <mat-tab
        label=""
        class="tab-item"
        [ngClass]="{ active: tab === tabs[0].name }"
        [disabled]="tabs[0].disabled"
      >
        <ng-template mat-tab-label>
          <div class="tab-item__content">
            <lum-ui-icon
              class="mr-2"
              [icon]="tabs[0].icon.name"
              [color]="tab === tabs[0].name ? '#3A47AF' : '#515673'"
              [width]="tabs[0].icon.width"
              [height]="tabs[0].icon.height"
            ></lum-ui-icon>
            <span class="tab-label">{{ tabs[0].label }}</span>
          </div>
        </ng-template>
        <lum-client-profile-info-form
          [form]="form"
          (tabChange)="onChangeTab(tabGroup, $event)"
          (tabValidation)="onCheckTabValidation($event)"
        ></lum-client-profile-info-form>
      </mat-tab>
      <!-- Client Business Address -->
      <mat-tab
        label=""
        class="tab-item"
        [ngClass]="{ active: tab === tabs[1].name }"
        [disabled]="tabs[1].disabled"
      >
        <ng-template mat-tab-label>
          <div class="tab-item__content">
            <lum-ui-icon
              class="mr-2"
              [icon]="tabs[1].icon.name"
              [color]="tab === tabs[1].name ? '#3A47AF' : '#515673'"
              [width]="tabs[1].icon.width"
              [height]="tabs[1].icon.height"
            ></lum-ui-icon>
            <span class="tab-label">{{ tabs[1].label }}</span>
          </div>
        </ng-template>
        <lum-client-profile-business-address-form
          [form]="form"
          (tabChange)="onChangeTab(tabGroup, $event)"
          (tabValidation)="onCheckTabValidation($event)"
        ></lum-client-profile-business-address-form>
      </mat-tab>
      <!-- Client Shipping Address -->
      <mat-tab
        label=""
        class="tab-item"
        [ngClass]="{ active: tab === tabs[2].name }"
        [disabled]="tabs[2].disabled"
      >
        <ng-template mat-tab-label>
          <div class="tab-item__content">
            <lum-ui-icon
              class="mr-2"
              [icon]="tabs[2].icon.name"
              [color]="tab === tabs[2].name ? '#3A47AF' : '#515673'"
              [width]="tabs[2].icon.width"
              [height]="tabs[2].icon.height"
            ></lum-ui-icon>
            <span class="tab-label">{{ tabs[2].label }}</span>
          </div>
        </ng-template>
        <ng-container *ngIf="mode === 'Create'; else edit">
          <ng-container *ngIf="!hasShippingAddress; else shippingAddressPanels">
            <lum-client-profile-shipping-address-form
              [form]="form"
              (tabChange)="onChangeTab(tabGroup, $event)"
              (tabValidation)="onCheckTabValidation($event)"
              (closeDialog)="onSaveShippingAddress($event)"
            ></lum-client-profile-shipping-address-form>
          </ng-container>
          <ng-template #shippingAddressPanels>
            <lum-client-profile-edit-shipping-address-form
              [form]="form"
              (tabChange)="onChangeTab(tabGroup, $event)"
            ></lum-client-profile-edit-shipping-address-form>
          </ng-template>
        </ng-container>
        <ng-template #edit>
          <lum-client-profile-edit-shipping-address-form
            [form]="form"
            (tabChange)="onChangeTab(tabGroup, $event)"
          ></lum-client-profile-edit-shipping-address-form>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
